var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('about-cover',{staticClass:"about-cover"}),_c('about-proposito',{staticClass:"about-proposito"}),_c('about-mentes',{staticClass:"about-mentes"}),_c('about-trajetoria',{staticClass:"about-trajetoria"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }